import { useNavigate } from "react-router-dom";

import useHttpManagedBase from "commons/hooks/useHttpManagedBase";

import { useAuthContext } from "context/auth";

export const baseUrl: string = "/backoffice/api/private";

function useHttpManaged() {
    const navigate = useNavigate();

    const { getAccessToken } = useAuthContext();

    return useHttpManagedBase({
        baseUrl: baseUrl,
        uiBaseUrl: "" + process.env.PUBLIC_URL,
        accessTokenGetter: getAccessToken,
        navigate: navigate,
    });
}

export default useHttpManaged;
